import { render, staticRenderFns } from "./ProductUnitsFormModal.vue?vue&type=template&id=d711a336&scoped=true&"
import script from "./ProductUnitsFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductUnitsFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d711a336",
  null
  
)

export default component.exports